import Api from "./api";
import { ajaxJWT } from "@/utils/request";

export function HAO_onsale_query(parameter) {
  return ajaxJWT({
    url: Api.hao_onsale_query,
    method: "post",
    data: parameter
  });
}

export function HAO_down(parameter) {
  return ajaxJWT({
    url: Api.hao_down,
    method: "post",
    data: parameter
  });
}
export function HAO_upper(parameter) {
  return ajaxJWT({
    url: Api.hao_upper,
    method: "post",
    data: parameter
  });
}
export function HAO_delete(parameter) {
  return ajaxJWT({
    url: Api.hao_delete,
    method: "post",
    data: parameter
  });
}
export function HAO_modify(parameter) {
  return ajaxJWT({
    url: Api.hao_modify,
    method: "post",
    data: parameter
  });
}

export function HAO_saled_query(parameter) {
  return ajaxJWT({
    url: Api.hao_saled_query,
    method: "post",
    data: parameter
  });
}

export function HAO_stock_query(parameter) {
  return ajaxJWT({
    url: Api.hao_stock_query,
    method: "post",
    data: parameter
  });
}
/**
 * 更新号码
 */
export function HAO_manage_empty() {
  return ajaxJWT({
    url: Api.hao_empty,
    method: "post",
    data: {}
  });
}
/**
 * 更新号码
 */
export function HAO_upload_list() {
  return ajaxJWT({
    url: Api.hao_upload_list,
    method: "post",
    data: {}
  });
}
